export const inventoryLoad = (restId, filter) => {
    return axios.get(`/chain/api/restaurants/${restId}/inventory`, {params: filter}).then(res => res.data);
}
export const inventoryChangeStatus = (restId, item, status) => {
    return axios.post(`/chain/api/restaurants/${restId}/inventory-status`, {item, status}).then(res => res.data);
}
export const inventoryUpdateType = (restId, item, type) => {
    return axios.post(`/chain/api/restaurants/${restId}/inventory-type`, {item, type}).then(res => res.data);
}
export const inventoryUpdateStockLimit = (restId, item, limit) => {
    return axios.post(`/chain/api/restaurants/${restId}/inventory-limit`, {item, limit}).then(res => res.data);
}
